// extracted by mini-css-extract-plugin
export var contactContainer = "contact-module--contactContainer--1rR9x";
export var innerContainer = "contact-module--innerContainer--1lN-S";
export var contactInfo = "contact-module--contactInfo--3WBAw";
export var item = "contact-module--item--1nipL";
export var image = "contact-module--image--1mhGJ";
export var message = "contact-module--message--3jZcQ";
export var items = "contact-module--items--1N6iR";
export var imageContainer = "contact-module--imageContainer--2JkpZ";